module.exports = __webpack_public_path__ + "static/media/touch.48529808.png";